// Uložení nastavení zobrazení k účtu (POST /app/prefs/, povolené klíče hlídá moodix/web/prefs.py).
// Chyba se jen zaloguje – stránka funguje dál, nastavení se jen nezapamatuje.
function csrf() {
  const m = document.cookie.match(/(?:^|; )csrftoken=([^;]+)/);
  return m ? decodeURIComponent(m[1]) : '';
}

export function savePref(key, value) {
  fetch('/app/prefs/', {
    method: 'POST', credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrf() },
    body: JSON.stringify({ key, value }),
  }).catch((err) => console.warn('Preference not saved', err));
}

/** Ikona „Reset view“: smaže uložená nastavení a načte stránku bez parametrů (výchozí zobrazení). */
export async function resetPrefs() {
  try {
    await fetch('/app/prefs/', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrf() },
      body: JSON.stringify({ reset: true }),
    });
  } finally {
    window.location.href = window.location.pathname;
  }
}
